var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7295 0.798828H2.94824C1.78513 0.798828 0.838867 1.74509 0.838867 2.9082V12.752C0.838867 13.9151 1.78513 14.8613 2.94824 14.8613H16.7295C17.8926 14.8613 18.8389 13.9151 18.8389 12.752V2.9082C18.8389 1.74509 17.8926 0.798828 16.7295 0.798828ZM17.4326 12.752C17.4326 13.1397 17.1172 13.4551 16.7295 13.4551H2.94824C2.56054 13.4551 2.24512 13.1397 2.24512 12.752V2.9082C2.24512 2.5205 2.56054 2.20508 2.94824 2.20508H16.7295C17.1172 2.20508 17.4326 2.5205 17.4326 2.9082V12.752Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletHorizontal);
export default __webpack_public_path__ + "static/media/tablet-horizontal.0eda2d5d481657b33233ca5517f04eda.svg";
export { ForwardRef as ReactComponent };